<script setup lang="ts">
import { darkModeLogo, lightModeLogo } from '@/assets/assetsUtils'
import {
    type ThemeModes,
    type ThemeProviderType,
    EColors,
    EProviders
} from '@rfc/rfc-components-library/types'
import { provide, ref } from 'vue'

const theme = ref<ThemeModes | undefined>(
    (document.documentElement.getAttribute('data-theme') as ThemeModes) ?? EColors.DARK
)

const setTheme = (value?: ThemeModes) => (theme.value = value)

provide<ThemeProviderType>(EProviders.THEME, { theme, setTheme, darkModeLogo, lightModeLogo })
</script>

<template>
    <slot v-bind="{ theme }" />
</template>
